const reasons = [
  {
    number: "01",
    icon: "ri-eye-line",
    title: "Spot Trends Before the Market Does",
    description: "We identify resale trends 1–2 weeks before they peak. By the time everyone else catches on, you've already sourced and listed."
  },
  {
    number: "02",
    icon: "ri-bar-chart-box-line",
    title: "Real Data, Not Guesswork",
    description: "Every issue is backed by live marketplace data from eBay, Poshmark, Whatnot, and more — not opinions or hunches."
  },
  {
    number: "03",
    icon: "ri-money-dollar-circle-line",
    title: "Know Exactly What to Pay",
    description: "We give you clear sourcing price ranges so you never overpay at a thrift store or estate sale again."
  },
  {
    number: "04",
    icon: "ri-store-2-line",
    title: "Sell on the Right Platform",
    description: "Not every item sells best on the same platform. We tell you exactly where each trending item moves fastest."
  },
  {
    number: "05",
    icon: "ri-calendar-check-line",
    title: "Every Thursday, No Fluff",
    description: "One focused report per week. Straight to the point, actionable intelligence you can use the same day you read it."
  },
  {
    number: "06",
    icon: "ri-rocket-line",
    title: "Built for Resellers at Every Level",
    description: "Whether you're flipping part-time or running a full operation, the BOLO Report gives you the edge to stay ahead."
  }
];

export default function WhySubscribe() {
  return (
    <section className="bg-[#e9eae4] py-28">
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-20">
          <span className="inline-block text-[#4d4d31] text-sm font-semibold tracking-widest uppercase mb-4 font-barlow">
            Why Subscribe
          </span>
          <h2 className="font-antonio text-5xl font-bold text-[#272727] mb-6 leading-tight uppercase">
            The unfair advantage<br />every reseller needs
          </h2>
          <p className="text-lg text-[#272727]/60 max-w-xl mx-auto leading-relaxed font-barlow">
            The resale market moves fast. The BOLO Report keeps you one step ahead — every single week.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {reasons.map((reason) => (
            <div
              key={reason.number}
              className="group bg-white hover:bg-[#272727] rounded-2xl p-8 transition-all duration-300 hover:-translate-y-1 cursor-default"
            >
              <div className="flex items-start justify-between mb-6">
                <div className="w-12 h-12 flex items-center justify-center bg-[#4d4d31]/10 group-hover:bg-[#4d4d31]/30 rounded-xl transition-colors">
                  <i className={`${reason.icon} text-2xl text-[#4d4d31] group-hover:text-[#e9eae4] transition-colors`}></i>
                </div>
                <span className="font-antonio text-4xl font-bold text-[#e9eae4] group-hover:text-[#e9eae4]/20 transition-colors leading-none">
                  {reason.number}
                </span>
              </div>
              <h3 className="font-antonio text-xl font-bold text-[#272727] group-hover:text-[#e9eae4] mb-3 transition-colors leading-snug uppercase">
                {reason.title}
              </h3>
              <p className="text-sm text-[#272727]/60 group-hover:text-[#e9eae4]/65 leading-relaxed transition-colors font-barlow">
                {reason.description}
              </p>
            </div>
          ))}
        </div>

        <div className="text-center mt-16">
          <a
            href="https://theboloreport.substack.com/subscribe?utm_source=menu&simple=true&next=https%3A%2F%2Ftheboloreport.substack.com%2F"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center space-x-2 bg-[#4d4d31] text-[#e9eae4] px-10 py-4 rounded-full text-base font-semibold hover:bg-[#3d3d25] transition-all hover:-translate-y-0.5 whitespace-nowrap cursor-pointer font-barlow tracking-wide"
          >
            <span>Start Reading Free</span>
            <i className="ri-arrow-right-line"></i>
          </a>
          <p className="text-sm text-[#272727]/50 mt-4 font-barlow">Free to read · Published every Thursday</p>
        </div>
      </div>
    </section>
  );
}
